import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'
import { IoMdArrowDropdown } from "react-icons/io"

export const PaymentCategoryDropdown = ({
    categoryInfo, 
    selectedCategory, 
    isOpen, 
    onToggleOpen, 
    onSelect
}) => {
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                onToggleOpen(false);
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen, onToggleOpen]);

    return (
        <StyledDropdown className='payment-category' ref={dropdownRef}>
            <h6>Payment category:</h6>
            <button className='category-selector' onClick={() => onToggleOpen(prev => !prev)}
            >
                {selectedCategory?.type || <span className='placeholder'>-- Select a payment category --</span>}
                <IoMdArrowDropdown className="dropdown-icon" />
            </button>
            {isOpen && (
                <div className="category-options-container">
                    {categoryInfo.map((category) => (
                        <div 
                            key={category.typeId} 
                            className="category-options"
                            onClick={() => onSelect(category)}
                        >
                            <h6>{category.type}</h6>
                        </div>
                    ))}
                </div>
            )}
        </StyledDropdown>
    );
};

const StyledDropdown = styled.div`
    margin-bottom: 2em;
    position: relative;

    .category-selector {
        width: 100%;
        height: 2.9rem;
        background-color: #EFF3F6;
        font-weight: 400;
        border: none;
        border-radius: 5px;
        text-align: left;
        padding-left: 15px;
        padding-left: 15px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .placeholder {
            font-style: Roboto;
            color: #777777;
        }

        .dropdown-icon {
            color: #777777;
            font-size: 1.5em;
        }
    }

    .category-options-container {
        width: 100%;
        border: 1px solid #EFF3F6;
        border-radius: 5px;
        box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
        background-color: white;

        .category-options {
            margin: 0rem;
            cursor: pointer;

            h6 {
                font-weight: 600;
                margin: 0;
                padding: 0.3rem;
            }

            h6:hover {
                background-color: #EFF3F6;
            }
        }
    }
`;

export default PaymentCategoryDropdown;